import { useFormContext } from 'react-hook-form';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TagInputField, useEmailValidationContext } from '@mews-commander/form';
import { FieldNames } from '../CommonPlatformProfileForm';
import { NewPlatformProfileFormValues } from './useNewPlatformProfileForm';

export const EmailsInputField = () => {
    const { trigger } = useFormContext<NewPlatformProfileFormValues>();

    const { invalidEmails } = useEmailValidationContext();

    const handleEmailsChange = async () => {
        await trigger(FieldNames.Emails);
    };

    return (
        <TagInputField
            name={FieldNames.Emails}
            label={<LocalizedText textKey={TextKey.EmailAddressPlural} />}
            helper={<LocalizedText textKey={TextKey.EmailAddressPluralHelper} />}
            required
            onChange={handleEmailsChange}
            invalidChips={invalidEmails}
            delimiters={[UnicodeEntity.Space, UnicodeEntity.Comma, UnicodeEntity.Semicolon, UnicodeEntity.NewLine]}
        />
    );
};
